import DialogModal, { ROOT_MODAL_ID } from './DialogModal';
import { DRAGGABLE_ELEMENT } from './PaperDraggable';

export default DialogModal;

export { DRAGGABLE_ELEMENT, ROOT_MODAL_ID };
